import { FC, useCallback } from 'react'
import SEOTable from 'container/SEOTools/components/SEOTable/SEOTable'

import { getRecentReportsColumn } from './columns'

import s from './RecentReportsTable.module.css'

import type { GapReport } from '@pepper/utils/src/types/seo'

type Props = {
  dataSource?: GapReport[]
  handleDelete: (reportId: string) => void
  totalRecords: number
  pageSize: number
  onPageChange: (pageNumber: number) => void
  page: number
  selectedRowKeys: React.Key[]
  onRowSelect: (items: React.Key[]) => void
  handleReportClick: (reportId: string, documentId: string) => void
}

export const RecentReportsTable: FC<Props> = ({
  dataSource,
  handleDelete,
  totalRecords,
  pageSize,
  onPageChange,
  page,
  selectedRowKeys,
  onRowSelect,
  handleReportClick,
}) => {
  const getRowKey = useCallback(
    (row: GapReport) => {
      return row.id
    },
    [dataSource]
  )
  return (
    <SEOTable
      className={s.table}
      rowKey={getRowKey}
      pagination={{
        total: totalRecords,
        pageSize,
        onChange: onPageChange,
        position: ['bottomRight'],
        showSizeChanger: false,
        current: page,
      }}
      dataSource={dataSource}
      columns={getRecentReportsColumn(
        handleDelete,
        selectedRowKeys,
        handleReportClick
      )}
      rowSelection={{
        type: 'checkbox',
        selectedRowKeys,
        onChange: onRowSelect,
      }}
      rowClassName={s.row}
    />
  )
}
